import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=17adbe1d&scoped=true&"
import script from "./ContentItem.vue?vue&type=script&lang=ts&"
export * from "./ContentItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=17adbe1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17adbe1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItem,VRow})
